import { Box, Button, Card, CardContent, Grid, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const MainAuthorsForm = observer(({ mainAuthorsFormStore: store }) => {
  return (
    <div>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid container spacing={2} item xs={12}>
              <Grid item xs={12}>
                <TextField label='Nome do autor'
                           onChange={e => store.setFormData('name', e.target.value)}
                           fullWidth
                           value={store.formData['name'] ?? ''} />
              </Grid>
            </Grid>
          </Grid>
          <br />
          <Grid container spacing={2}>
            <Grid item xs={2}>
              {store.loadedImage && (
                <Box><img alt='cover' src={store.loadedImage}
                          style={{
                            maxWidth: '100%',
                            clipPath: 'circle(closest-side at center',
                          }} /><br /><br /></Box>)}

              <TextField label='Url da Imagem'
                         onChange={e => store.setFormData('image', e.target.value)}
                         fullWidth
                         value={store.formData['image'] ?? ''} />
              <Button onClick={e => store.setLoadedImage(store.formData.image)}>Carregar imagem</Button>
              <Button onClick={e => store.setLoadedImage(null)} color='error'>Carregar Capa Padrão</Button>
            </Grid>
            <Grid item xs={12} sm container sx={{ alignContent: 'flex-start' }} spacing={2}>
              <Grid item xs={12}>
                <TextField error={store.errors['bio']} label='Bio do Autor'
                           onChange={e => store.setFormData('bio', e.target.value)}
                           fullWidth rows={5} multiline
                           value={store.formData['bio']} />
              </Grid>
              <Grid item xs={8}>
                <TextField error={store.errors['site']} label='Site do autor'
                           onChange={e => store.setFormData('site', e.target.value)}
                           fullWidth
                           value={store.formData['site']} />
              </Grid>
              <Grid item xs={4}>
                <TextField error={store.errors['instagram']} label='Instagram (@) do autor'
                           onChange={e => store.setFormData('instagram', e.target.value)}
                           fullWidth
                           value={store.formData['instagram']} />
              </Grid>
              <Grid item xs={6}>
                <TextField error={store.errors['bio_source']} label='Fonte da Bio do Autor'
                           onChange={e => store.setFormData('bio_source', e.target.value)}
                           fullWidth
                           value={store.formData['bio_source']} />
              </Grid>
              <Grid item xs={6}>
                <TextField error={store.errors['image_source']} label='Fonte da Imagem do Autor'
                           onChange={e => store.setFormData('image_source', e.target.value)}
                           fullWidth
                           value={store.formData['image_source']} />
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Grid container marginTop={2} sx={{justifyContent: 'flex-end'}}>
          <Button variant='contained'
                  size="large" disabled={store.tabsErrors[0] || store.loading}
                  onClick={() => store.saveMainAuthor()}>Salvar Autor-pai</Button>
      </Grid>
    </div>
  );
});

export default MainAuthorsForm;
